import React from "react";
import ScrollToTop from "../companants/ScrollToTop";
import Navbar from "../companants/Navbar";
import Footware from "../companants/Footware";
import HomeApp from "../pages/Home/HomeApp";
import AboutApp from "../pages/About/AboutApp";
import ServicesApp from "../pages/Services/ServicesApp";
import GalleryApp from "../pages/Gallery/GalleryApp";
import ContactApp from "../pages/Contact/ContactApp";

import { BrowserRouter, Routes, Route } from "react-router-dom";
export default function App() {
  return (
    <BrowserRouter>
     <ScrollToTop />
      <Navbar />

      <Routes>
        <Route path="/" element={<HomeApp />} />
        <Route path="/about" element={<AboutApp />} />
        <Route path="/services" element={<ServicesApp />} />
        <Route path="/gallery" element={<GalleryApp />} />
        <Route path="/contact" element={<ContactApp />} />
      </Routes>
      <Footware/>
    </BrowserRouter>
  );
}


